<template>
	<div>
		<j-card
			class="bg5 p3 fs3 flex xs-center"
			v-if="!clauses || clauses.length === 0"
			>{{ $t("errors.no_data") }}
		</j-card>
		<div class="clause-list bg4 p4" v-else>
			<j-card
				class="xs-column bg5 p2 mb2"
				v-for="(clause, i) in clauses"
				:key="i"
			>
				<!-- Top -->
				<div v-if="clause.template" class="flex xs-12 xs-column mb2">
					<!-- Name -->
					<div class="flex xs-middle mb2 pl2 pr2 fw7">
						<!-- <p class="mr1 fs3 c6">{{ $t("name") }}:</p> -->
						<p class="fs3">{{ clause.template.name }}</p>
					</div>
					<!-- renderedHtmlResult -->
					<div class="pl2 pr4">
						<div
							class="fs3 lh150"
							v-html="clause.htmlOverride || clause.renderedHtmlResult.value"
						></div>
					</div>
				</div>

				<!-- Order -->
				<div class="flex bc7 bt1">
					<div class="flex xs-6 xs-middle p2">
						<div class="fw7 fs3">{{ $t("order") }}</div>
						<div class="ml2 fs3">{{ clause.order }}</div>
					</div>

					<div v-if="showRemoveButton" class="flex xs-6 xs-right xs-middle pt2">
						<j-button
							class="mr1"
							size="xsmall"
							type="secondary"
							@click="updateClause(clause)"
						>
							<crm-icon name="edit" size="small" color="c5"></crm-icon>
							{{ $t("update") }}
						</j-button>
						<j-button size="xsmall" type="error" @click="removeClause(clause)">
							<crm-icon name="delete" size="small" color="c5"></crm-icon>
							{{ $t("remove") }}
						</j-button>
					</div>
				</div>
			</j-card>
		</div>
		<!-- Add Button -->
		<div v-if="showButtons" class="p4 bg4">
			<div class="flex xs-right xs-12">
				<j-button size="xsmall" @click="addClause">{{
					$t("add_clause")
				}}</j-button>
			</div>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import JCard from "@/components/JCard/"

export default {
	name: "Clauses",
	props: {
		clauses: Array,
		showButtons: {
			type: Boolean,
			required: false,
			default: true
		},

		// Remove is only for unissued policy, not endorsement
		showRemoveButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	components: {
		JButton,
		CrmIcon,
		JCard
	},
	methods: {
		updateClause(clause) {
			this.$emit("clauses_update", { value: clause })
		},
		addClause() {
			this.$emit("clauses_add", {
				value: {
					order: null,
					templateId: null,
					renderParameters: {
						name: "data",
						contentJsonString: null,
						variablesJsonString: null
					}
				}
			})
		},
		removeClause(clause) {
			this.$emit("clauses_remove", { clauseId: clause.id })
		}
	}
}
</script>

<style></style>
